import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      email
      image
      isConfirmed
      language
      role
      suspended
      type
      FCMtoken
      userId
      username
      monday
      tuesday
      thursday
      wednesday
      friday
      saturday
      sunday
      night
      hours
      readedAt
      __typename
    }
  }
  `;

export const shiftsByUser = gql/* GraphQL */ `query ShiftsByUser(
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
  $userId: ID!
) {
  shiftsByUser(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
    userId: $userId
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        image
      }
    }
    nextToken
    __typename
  }
}
`;

export const getAgendaShift = gql/* GraphQL */ `query GetAgendaShift($shiftId: ID!) {
  getAgendaShift(shiftId: $shiftId) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      items {
        honorId
        userId
        shiftId
        type
        createdAt
        updatedAt
      }
      nextToken
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const punchsByShift = gql/* GraphQL */ `
  query PunchsByShift(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgendaPunchFilterInput
    $limit: Int
    $nextToken: String
    $shiftId: ID!
    $sortDirection: ModelSortDirection
  ) {
    punchsByShift(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      shiftId: $shiftId
      sortDirection: $sortDirection
    ) {
      items {
        accuracy
        altitude
        createdAt
        deleted
        heading
        latitude
        longitude
        punchId
        shiftId
        speed
        startAt
        stopAt
        timestamp
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const shiftAppsByComId = gql/* GraphQL */ `query ShiftAppsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftAppsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const updateAgendaShift = gql/* GraphQL */ `mutation UpdateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: UpdateAgendaShiftInput!
) {
  updateAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const createAgendaShift = /* GraphQL */ `mutation CreateAgendaShift(
  $condition: ModelAgendaShiftConditionInput
  $input: CreateAgendaShiftInput!
) {
  createAgendaShift(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const shiftsByComId = gql/* GraphQL */ `query ShiftsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      performance
      punctuality
      quality
      rate
      role
      shiftAppId
      shiftId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        userId
        username
        email
        image
        FCMtoken
      }
    }
    nextToken
    __typename
  }
}
`;

  export const usersByComId = gql/* GraphQL */ `
  query UsersByComId(
    $comId: ID!
    $filter: ModelAgendaUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    usersByComId(
      comId: $comId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        FCMtoken
        comId
        createdAt
        email
        firstName
        image
        isConfirmed
        language
        lastName
        password
        phoneNumber
        profileOwner
        readedAt
        role
        suspended
        type
        updatedAt
        userId
        username
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

export const onCreateAgendaShiftByUserId = gql/* GraphQL */ `subscription OnCreateAgendaShiftByUserId($userId: ID) {
  onCreateAgendaShiftByUserId(userId: $userId) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const createAgendaShiftByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftByUserId(
  $accepted: Boolean
  $comId: ID
  $confirmed: Boolean
  $createdAt: AWSDateTime
  $deleted: Boolean
  $info: String
  $location: String
  $performance: String
  $punctuality: String
  $quality: String
  $rate: String
  $role: String
  $shiftAppId: ID
  $shiftId: ID!
  $startAt: AWSDateTime
  $stopAt: AWSDateTime
  $suspended: Boolean
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
  $lat: String
  $lng: String
) {
  createAgendaShiftByUserId(
    accepted: $accepted
    comId: $comId
    confirmed: $confirmed
    createdAt: $createdAt
    deleted: $deleted
    info: $info
    location: $location
    performance: $performance
    punctuality: $punctuality
    quality: $quality
    rate: $rate
    role: $role
    shiftAppId: $shiftAppId
    shiftId: $shiftId
    startAt: $startAt
    stopAt: $stopAt
    suspended: $suspended
    updatedAt: $updatedAt
    userId: $userId
    username: $username
    lat: $lat
    lng: $lng
  ) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;